// Copyright 2026. WebPros International GmbH. All rights reserved.

import { IShortComputeResourceResponse } from 'common/api/resources/ComputeResource';
import { IShortVmResponse } from 'common/api/resources/ComputeResourceVm';
import {
    IPaginated,
    IRequest,
} from 'common/api/resources/Request/request';
import { IPaginateApiResponse } from 'common/api/resources/Response';
import { ITaskResponse } from 'common/api/resources/Task';

export interface IShortFailoverDomainResponse {
    id: number;
    name: string;
}

export interface IHighAvailabilityActivity {
    id: number;
    source_compute_resource: IShortComputeResourceResponse;
    failover_domain: IShortFailoverDomainResponse | null;
    status: HighAvailabilityStatus;
    started_at: string | null;
    ended_at: string | null;
    entities_count: {
        total: number;
        failed: number;
        cancelled: number;
    };
    is_loading?: boolean;
    entities?: IPaginateApiResponse<IHighAvailabilityActivityEntity[]>;
}

export interface IHighAvailabilityActivityEntity {
    id: number;
    compute_resource_vm: IShortVmResponse;
    status: HighAvailabilityEntityStatus;
    task?: ITaskResponse;
    move_back_task?: ITaskResponse;
    started_at: string | null;
    ended_at: string | null;
    destination_compute_resource: IShortComputeResourceResponse | null;
    is_migrated_back: boolean;
    is_loading?: boolean;
    is_move_back_pending?: boolean;
    high_availability: IHighAvailabilityActivity;
}

export enum HighAvailabilityStatus {
    PENDING = 'pending',
    RUNNING = 'running',
    RUNNING_WITH_ERRORS = 'running_with_errors',
    FAILED = 'failed',
    COMPLETED = 'completed',
    COMPLETED_WITH_ERRORS = 'completed_with_errors',
    CANCELLED = 'cancelled',
}

export enum HighAvailabilityEntityStatus {
    PENDING = 'pending',
    RUNNING = 'running',
    FAILED = 'failed',
    COMPLETED = 'completed',
    CANCELLED = 'cancelled',
}

export interface IHighAvailabilityActivityRequestFilters {
    status?: string;
    source_compute_resource_id?: number;
}

export interface IHighAvailabilityActivityRequest extends IRequest<
    IHighAvailabilityActivityRequestFilters
>, IPaginated {}

export interface IHighAvailabilityActivityEntitiesRequest extends IPaginated {}

export interface IUpdateHighAvailabilityActivityEntity {
    entity: IHighAvailabilityActivityEntity;
}

export interface IHighAvailabilityActivityMoveBackRequest {
    high_availability_activity_ids?: number[];
    entity_ids?: number[];
}
